import { css } from '@emotion/react';

export default () => css`
  .workpage {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    height: 100%;
    gap: 16px;
    background-color: #ffffff;

    .dashboard {
      height: 100%;
    }

    .workpage-widget {
      height: 100%;
      min-height: 0;
    }
  }

  .workTrayIcon {
    padding-bottom: 20px;

    img {
      cursor: pointer;
      max-width: 143px;
    }

    .label {
      p {
        font-size: 19px !important;
        margin: 0px;
        font-weight: bold;
      }
    }
  }

  .td-actionButtons {
    display: flex;
    justify-content: space-between;
    gap: 5px;
  }

  .shift-viewer-filters .control-label {
    display: block !important;
  }

  .shift-viewer-card {
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    background: #f5f5f5;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  .worktray {
    height: 100%;
    display: flex;
    flex-direction: column;

    > .card:not(:first-of-type) {
      flex-grow: 1;
      min-height: 0;
    }

    > .card {
      position: relative;

      > .card-header .worktray-description {
        margin-top: -6px;
      }

      > .worktray-table-container {
        min-height: 100px;
        width: 100%;
        height: 100%;
        overflow: auto;
        position: relative;

        &.full-height > .table {
          height: 100%;
        }

        > .table {
          flex-grow: 1;
          margin-bottom: 0;
          overflow: visible;

          > thead {
            position: sticky;
            top: 0;
            background-color: #ffffff;
            z-index: 1;
          }

          > * > tr {
            > td,
            > th {
              padding: 0.32rem 0rem 0.32rem 0.25rem;

              > .btn {
                white-space: nowrap;
                text-overflow: clip;
                margin: auto;
              }
            }

            > td:has(.btn) {
              display: flex;
              height: 100%;
              width: 100%;
              align-items: center;
            }
          }

          .loader-container {
            background-color: #ffffff;

            > td {
              vertical-align: middle;
            }
          }

          .empty-state {
            text-align: center;
            padding: 1rem 0;
            width: fit-content;
            margin: auto;
            padding-left: 2rem;
            padding-right: 2rem;
          }

          .error-container > td {
            height: fit-content;
          }
        }
      }
    }

    .worktray-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .worktray-header-actions {
          float: right;
          display: flex;
          align-items: center;
          gap: 4px;
      }

      .worktray-action-btn {
          font-size: 10pt;
          height: min-content;
      }
    }
      
  }

  .show-when-mobile {
    display: none;
  }

  .worktray-datacell {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
  }

  @media (max-width: 850px) {
    .mobile-workpage {
      height: auto;
      display: flex;
      flex-direction: column;

      &:has(> :only-child) {
        height: 100%;
      }
    }

    .worktray-table-container {
      display: none;
    }

    .mobile-table {
      > div:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, 0.05);
      }

      > .card {
        border: none;
      }

      > .empty-state,
      > .loader-container {
        padding: 2rem;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        > .alert {
          width: fit-content;
          padding-left: 2rem;
          padding-right: 2rem;
        }
      }
    }

    @media (max-width: 768px) {
      .worktray > .card > .card-header .worktray-description {
        display: none;
      }
    }
  }
`;
